export const toEditorType = (...ids) => {
    return ids.map(id => `[data-gjs-type="${id}"]`).join(',');
};

export const elHasTagName = (el, ...tags) => {
    return tags.indexOf(el?.tagName?.toUpperCase()) >= 0;
}

export const elHasClassName = (el, className) => {
    return el?.classList?.contains(className);
}

export const elHasAttribute = (el, attrName) => {
    return !!el?.getAttribute?.(attrName);
}

export const getBlockIndex = (editor, blockId) => {
    const block = editor.Blocks.get(blockId);
    return block ? block.collection.indexOf(block) : -1;
}

export const toSafeFilename = (value) => value.replace(/[^a-z0-9.]/gi, '_').toLowerCase();

export const getPageSlug = (editor, page) => {
    const {Pages} = editor;
    const index = Pages.getAll().indexOf(page);
    const filename = index === 0 ? 'index' : toSafeFilename(page.getName());
    return `${filename}.html`;
}